import React, {Component, PropTypes} from 'react';
import {autobind} from 'core-decorators';
import classNames from 'classnames';

export default class TextInput extends Component {
    static propTypes = {
        value: PropTypes.string,
        placeholder: PropTypes.string,
        grow: PropTypes.bool,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        value: '',
        placeholder: undefined,
        grow: false,
        disabled: false,
        onChange: undefined,
    };

    state = {value: this.props.value};

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) this.setState({value: nextProps.value});
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.value !== this.state.value
            || nextProps.value !== this.props.value
            || nextProps.placeholder !== this.props.placeholder
            || nextProps.grow !== this.props.grow
            || nextProps.disabled !== this.props.disabled
            || nextProps.onChange !== this.props.onChange;
    }

    @autobind
    handleChange(event) {
        const {value} = event.target;
        this.setState({value});
        if (this.props.onChange) {
            clearTimeout(this.changeTimeoutId);
            this.changeTimeoutId = setTimeout(this.props.onChange, 500, value);
        }
    }

    render() {
        const {value} = this.state;
        const {placeholder, grow, disabled} = this.props;

        return (
            <div
                className={classNames(
                    'cielo24-vwrap-form-text-input',
                    {
                        'cielo24-vwrap-grow': grow,
                        'cielo24-vwrap-disabled': disabled,
                    },
                )}
            >
                <input
                    type='text'
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    onChange={this.handleChange}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/forms/text-input.js